import { motion } from "framer-motion";
import { TESTIMONIALS } from "@/constants/testIds";

const quotes = [
  {
    quote:
      "My son left BBA a completely different player. Sean doesn't just train — he develops the player and the person.",
    name: "Marcus T.",
    role: "Parent · Class of 2025",
  },
  {
    quote:
      "The film study sessions changed how I see the game. I read defenses now. That's the difference at the next level.",
    name: "Jordan R.",
    role: "Player · Committed D1",
  },
  {
    quote:
      "Best development program in the Midwest, hands down. The connections opened doors we didn't know existed.",
    name: "Tara M.",
    role: "Parent · Travel Team",
  },
];

export default function Testimonials() {
  return (
    <section
      id="testimonials"
      data-testid={TESTIMONIALS.section}
      className="section-pad bg-[#03080F]"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="max-w-2xl mb-14">
          <div className="overline">Voices</div>
          <div className="gold-divider mt-4 mb-6" />
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl tracking-tight">
            What families and players{" "}
            <span className="text-[#B8C5D6]">are saying.</span>
          </h2>
        </div>

        <div className="grid md:grid-cols-3 gap-6 lg:gap-8">
          {quotes.map((q, i) => (
            <motion.figure
              key={q.name}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.2 }}
              transition={{ duration: 0.6, delay: i * 0.12 }}
              className="bba-card relative p-8 sm:p-10 overflow-hidden"
            >
              <div className="quote-mark absolute -top-2 left-4 select-none">
                "
              </div>
              <blockquote className="relative text-white/90 text-base sm:text-lg leading-relaxed">
                {q.quote}
              </blockquote>
              <figcaption className="relative mt-8 pt-6 border-t border-white/10">
                <div className="font-display text-base">{q.name}</div>
                <div className="text-xs tracking-[0.2em] uppercase text-[#B8C5D6] mt-1">
                  {q.role}
                </div>
              </figcaption>
            </motion.figure>
          ))}
        </div>
      </div>
    </section>
  );
}
